export const AUTHORIZATION_HEADER = 'c61de580-e48d-41d2-a8d1-6cd1429987a1';
